import { render } from "./QuizPanelView.vue?vue&type=template&id=2f0d34c4"
import script from "./QuizPanelView.vue?vue&type=script&lang=js"
export * from "./QuizPanelView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__